<template>
  <div class="table-container" v-if="tableData && tableData.length">
        <table >
            <colgroup>
              <col v-for="(width, index) in columnWidths" :key="index" :style="{ width: `${width}px` }">
            </colgroup>
            <thead>
                <tr>
                    <th 
                      v-for="(headItem,headIndex) in tableData[0].colData" 
                      :key="`head${headIndex}`"
                      >{{ headItem.label }}</th>
                      <!-- :style="{ width: columnWidths[headIndex] + 'px' }" -->
                    <th class="fixed-column" style="width: 41px;color: #3D3833;">操作</th>
                </tr>
            </thead>
            <tbody>
                <tr
                  v-for="(row,rowIndex) in tableData"
                  :key="row.class"
                  :class="['table-row',row.class]"
                >
                    <td
                      v-for="cell in row.colData"
                      :key="cell.class"
                      :class="['table-col',`col${cell.col}`,cell.class]"
                      >
                        <div style="display: flex;align-items: center;justify-content: center;word-break: break-all;">
                            <div 
                                class="abnormal-cell__error" 
                                v-if="cell.abnormalData && cell.abnormalData.errorData"
                            >{{ cell.abnormalData.errorData.message }}</div>
                            <van-icon 
                                name="warning" 
                                class="abnormal-cell__warning" 
                                v-else-if="cell.abnormalData && cell.abnormalData.warningData" 
                                size="12px"
                                color="#FFC11B"
                                @click="handleWarningToast(cell)"
                            />
                            {{ cell.value }}
                        </div>
                      </td>
                      <!-- :style="{ width: columnWidths[cell.col] + 'px' }" -->
                    <td class="fixed-column" style="width: 41px;">
                        <div style="color: #669EE6;margin-bottom: 8px;" class="fixed-column__button" @click="handleEdit(row)">修改</div>
                        <div style="color: #FF484A;" class="fixed-column__button" @click="handleRemove(row,rowIndex)">移除</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs';
import { parseTime } from "@/utils/index.js";
import { Icon } from 'vant';
export default {
    components: {
        [Icon.name]: Icon,
    },
    inject: ["getTemplateActive","getForm","modal"],
    data(){
        return {
            tableHeadData:[],
            tableData: [],
            columnWidths: [],
            minColumnWidth: 45, // 最小列宽
            maxColumnWidth: 200,  // 最大列宽
            // excel列
            tmsExcelColOptions: [
                { tmsLabel: "序号" , keyName: "serialNumber" , materialSupplierLabel: "" },
                { tmsLabel: "发料日期" , keyName: "issueTime" , materialSupplierLabel: "" },
                { tmsLabel: "物料编码" , keyName: "materialCode" , materialSupplierLabel: "" },
                { tmsLabel: "发料数量" , keyName: "issueNumber" , materialSupplierLabel: "" },
                { tmsLabel: "送货地点" , keyName: "deliveryLocation" , materialSupplierLabel: "" },
                { tmsLabel: "领料仓库" , keyName: "materialWarehouse" , materialSupplierLabel: "" },
                { tmsLabel: "华勤料号" , keyName: "hqMaterialCode" , materialSupplierLabel: "" },
                { tmsLabel: "在用项目" , keyName: "inUseProject" , materialSupplierLabel: "" },
                { tmsLabel: "工作中心" , keyName: "workCenter" , materialSupplierLabel: "" },
                { tmsLabel: "物料类别" , keyName: "materialType" , materialSupplierLabel: "" },
                { tmsLabel: "物料描述" , keyName: "materialDescription" , materialSupplierLabel: "" },
                { tmsLabel: "备注" , keyName: "remark" , materialSupplierLabel: "" },
            ],
            abnormalData: [],
            warningPositionCurrent: -1,
            warningPositionList: [],
        }
    },
    created(){
       this.$bus.on("materialDataFormSubmit",this.materialDataFormSubmit); 
    },
    beforeDestroy(){
        this.$bus.off("materialDataFormSubmit",this.materialDataFormSubmit);
    },
    methods: {
        validate({ excelData }){
            // 设置已选模板的物料字段
            let templateActive = this.getTemplateActive();
            this.tmsExcelColOptions = this.tmsExcelColOptions.map(item => ({
                ...item,
                materialSupplierLabel: item.keyName === "serialNumber" ? "序号" : (templateActive[item.keyName] || "")
            }));
            // 校验读取的 excel 是否少列
            try {
                let newExcelData = excelData.map(excelRow => {
                    return this.tmsExcelColOptions.reduce((newItem,tmsOptionItem) => {
                        if(!excelRow.hasOwnProperty(tmsOptionItem.materialSupplierLabel)) {
                            throw new Error(`模板表格缺少字段：${tmsOptionItem.materialSupplierLabel}`);
                        }else if(tmsOptionItem.keyName === "issueTime") {
                            // 处理日期格式，Excel 内部将日期存储为自 1900 年 1 月 1 日起的天数，所以"2024/6/5"这样的格式读取出来是一个数字45448
                            let date = excelRow[tmsOptionItem.materialSupplierLabel] ? this.excelDateToJSDate(excelRow[tmsOptionItem.materialSupplierLabel]) : undefined;
                            return {
                               ...newItem,
                                [tmsOptionItem.tmsLabel]: date ? parseTime(date,"{y}-{m}-{d}") : excelRow[tmsOptionItem.materialSupplierLabel],
                            }
                        }else {
                            return {
                                ...newItem,
                                [tmsOptionItem.tmsLabel]: excelRow[tmsOptionItem.materialSupplierLabel],
                            }
                        }
                    },{})
                }).filter(item => !Object.keys(item).every(tmsLabel => !item[tmsLabel]));
                return Promise.resolve(newExcelData);
            } catch (error) {
                this.$loading.close();
                this.$dialog.alert({
                    message: error,
                    allowHtml:false,
                    confirmButtonColor:'#EC892E'
                });
                return Promise.reject(error);
            }
        },
        excelFileToJson(file){
            return new Promise(async(resolve,reject) => {
                try {
                    if(!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')){
                        this.$dialog.alert({
                            message: "不支持的文件格式，请选择.xlsx或.xls格式的Excel文件",
                            allowHtml:false,
                            confirmButtonColor:'#EC892E'
                        });
                        return reject("不支持的文件格式");
                    };
                    let res;
                    if (file.name.endsWith('.xlsx')) {
                        res = await this.xlsxRead(file);
                    } else if (file.name.endsWith('.xls')) {
                        res = await this.xlsRead(file);
                    };
                    if(res && res.length && res[0].data && res[0].data.length) {
                        let data = res[0].data;
                        // return reject(false);
                        let newExcelData = await this.validate({ excelData: data });
                        let tableData = newExcelData.reduce((list,row,rowIndex) => {
                            let colData = Object.keys(row).map((key,colIndex)=>({
                                label: key,
                                value: row[key],
                                class: `row${rowIndex+1}-col${colIndex+1}`,
                                rowIndex: rowIndex,
                                colIndex: colIndex,
                                keyName: this.tmsExcelColOptions.find(tmsExcelColItem => tmsExcelColItem.tmsLabel === key).keyName,
                            }));
                            return [...list,{
                                colData,
                                class: `row${rowIndex+1}`,
                                rowIndex: rowIndex
                            }];
                        },[]);
                        let tableHeadData = Object.keys(tableData[0]);
                        let columnWidths = this.calculateColumnWidths({ tableData , tableHeadData });
                        resolve({
                            tableData,
                            tableHeadData,
                            columnWidths
                        });
                    }else {
                        // this.tableData = [];
                        // this.tableHeadData = [];
                        // this.columnWidths = [];
                        this.$dialog.alert({
                            message: "文件数据为空，请检查文件内容",
                            allowHtml:false,
                            confirmButtonColor:'#EC892E'
                        });
                        reject("文件内容为空");
                    }
                } catch (error) {
                    reject(error);
                }

            })
        },
        // xlsx
        xlsxRead(file){
            return new Promise((resolve,reject) => {
                const reader = new FileReader();
                reader.onload =  (e) => {
                    const data = new Uint8Array(e.target.result);
                    let workbook;
                    try {
                        workbook = XLSX.read(data, { type: 'array' });
                        const jsonData = [];
                        workbook.SheetNames.forEach((sheetName,sheetIndex) => {
                            if(sheetIndex) return;
                            const worksheet = workbook.Sheets[sheetName];
                            const headers = [];
                            const sheetData = [];
    
                            // 提取表头（假设第一行为表头）
                            const headerRow = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
                            headerRow.forEach(header => headers.push(header));
    
                            // 处理数据行（从第二行开始）
                            const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                            for (let i = 1; i < rows.length; i++) {
                                const row = rows[i];
                                const rowData = {};
                                for (let j = 0; j < headers.length; j++) {
                                    rowData[headers[j]] = row[j];
                                }
                                sheetData.push(rowData);
                            }
    
                            jsonData.push({
                                sheetName: sheetName,
                                data: sheetData
                            });
                        });
                        // resultDiv.innerHTML = JSON.stringify(jsonData, null, 4);
                        resolve(jsonData);
                    } catch (error) {
                        this.$loading.close();
                        console.error("读取Excel文件出错:", error);
                        // resultDiv.innerHTML = "读取Excel文件出错，请检查文件格式是否正确";
                        this.$dialog.alert({
                            message: "读取Excel文件出错，请检查文件格式是否正确",
                            allowHtml:false,
                            confirmButtonColor:'#EC892E'
                        });
                        return reject(error);
                    };
                };
                reader.readAsArrayBuffer(file);
            })
        },
        // xls
        xlsRead(file){
            return new Promise((resolve,reject) => {
                // 对于.xls格式，尝试用SheetJS提供的额外方式处理（可能有兼容性限制）
                const binaryData = [];
                const readerForXls = new FileReader();
                readerForXls.onload = (event) => {
                    const ab = event.target.result;
                    const dataView = new DataView(ab);
                    const Uint8Arr = new Uint8Array(dataView.byteLength);
                    for (let i = 0; i < dataView.byteLength; i++) {
                        Uint8Arr[i] = dataView.getUint8(i);
                    };
                    let workbookForXls;
                    try {
                    workbookForXls = XLSX.read(binaryData, { type: 'array' });
                    } catch (error) {
                    console.error("读取Excel文件出错:", error);
                    // resultDiv.innerHTML = "读取Excel文件出错，请检查文件格式是否正确";
                    this.$dialog.alert({
                        message: "读取Excel文件出错，请检查文件格式是否正确",
                        allowHtml:false,
                        confirmButtonColor:'#EC892E'
                    });
                    return reject(error);
                    }
                    const jsonData = [];
                    workbookForXls.SheetNames.forEach(sheetName => {
                        const worksheet = workbookForXls.Sheets[sheetName];
                        const headers = [];
                        const sheetData = [];
                        // 提取表头（假设第一行为表头）
                        const headerRow = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
                        headerRow.forEach(header => headers.push(header));

                        // 处理数据行（从第二行开始）
                        const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        for (let i = 1; i < rows.length; i++) {
                            const row = rows[i];
                            const rowData = {};
                            for (let j = 0; j < headers.length; j++) {
                                rowData[headers[j]] = row[j];
                            }
                            sheetData.push(rowData);
                        }

                        jsonData.push({
                            sheetName: sheetName,
                            data: sheetData
                        });
                    });
                    // 后续处理同.xlsx格式类似，这里可以提取出一个公共函数来复用代码
                    // 为简化示例，暂省略完整的相同逻辑代码重复部分
                    // 只输出简单提示信息表示尝试处理了.xls格式
                    // resultDiv.innerHTML = "暂仅部分支持.xls格式，可能转换结果不准确，建议使用.xlsx格式";
                    /* this.$dialog.alert({
                    message: "暂仅部分支持.xls格式，可能转换结果不准确，建议使用.xlsx格式",
                    allowHtml:false,
                    confirmButtonColor:'#EC892E'
                    }); */
                resolve(jsonData);
                };
                readerForXls.readAsArrayBuffer(file);
            })
        },
        excelDateToJSDate(serial) {
            const utc_days = Math.floor(serial - 25569);
            const utc_value = utc_days * 86400;
            const date_info = new Date(utc_value * 1000);

            const fractional_day = serial - Math.floor(serial) + 0.0000001;

            let total_seconds = Math.floor(86400 * fractional_day);

            const seconds = total_seconds % 60;

            total_seconds -= seconds;

            const hours = Math.floor(total_seconds / (60 * 60));
            const minutes = Math.floor(total_seconds / 60) % 60;

            return new Date(
                date_info.getFullYear(),
                date_info.getMonth(),
                date_info.getDate(),
                hours,
                minutes,
                seconds
            );
        },
        calculateColumnWidths({ tableData }) {
            const numColumns = tableData[0].colData.length;
            const maxWidths = new Array(numColumns).fill(0);

            // 计算每列的最大内容宽度
            tableData.forEach(row => {
                row.colData.forEach((cell, colIndex) => {
                const cellWidth = this.measureTextWidth(cell.value);
                maxWidths[colIndex] = Math.max(maxWidths[colIndex], cellWidth);
                });
            });

            // 考虑表头宽度
            tableData[0].colData.forEach((cell, colIndex) => {
                const headerWidth = this.measureTextWidth(cell.label);
                maxWidths[colIndex] = Math.max(maxWidths[colIndex], headerWidth);
            });

            // 应用最小和最大列宽限制
            let columnWidths = maxWidths.map(width => {
                return Math.min(Math.max(width, this.minColumnWidth), this.maxColumnWidth);
            });
            return columnWidths;
        },
        measureTextWidth(text) {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            // 这里需要根据实际的表格字体样式调整
            context.font = '16px Arial'; 
            return context.measureText(text).width; // 加20px的内边距
        },
        // 异常数据处理
        handleAbnormalData(abnormalData){
            this.abnormalData = abnormalData || {};
            let errorDataRowCurrentList = [];
            let warningDataRowCurrentList = [];
            this.tableData = this.tableData.map((row,rowIndex) => {
                let newRow = this.deepClone(row);
                // 筛选出当前行的错误信息
                if(this.abnormalData.errorMessageList && this.abnormalData.errorMessageList.length) {
                    errorDataRowCurrentList = this.abnormalData.errorMessageList.filter(abnormalItem => abnormalItem.rawIndex === rowIndex);
                }
                // 筛选出当前行的警告信息
                if(this.abnormalData.warningMessageList && this.abnormalData.warningMessageList.length) {
                    warningDataRowCurrentList = this.abnormalData.warningMessageList.filter(abnormalItem => abnormalItem.rawIndex === rowIndex);
                };

                if(!errorDataRowCurrentList.length && !warningDataRowCurrentList.length) {
                    // 清除异常数据
                    newRow.colData.forEach(cell => {
                        cell.abnormalData = undefined;
                    });
                    return newRow;
                };

                // 设置异常数据
                errorDataRowCurrentList.forEach(abnormalItem => {
                    let keyName = abnormalItem.filedName;
                    let abnormalCell = newRow.colData.find(colItem => colItem.keyName === keyName);
                    if(abnormalCell) {
                        if(abnormalCell.abnormalData) {
                            abnormalCell.abnormalData.errorData = {
                                ...abnormalItem,
                                tagType: "error"
                            }
                        }else {
                            abnormalCell.abnormalData = {
                                errorData: {
                                    ...abnormalItem,
                                    tagType: "error"
                                }
                            }
                        }
                    }
                });

                // 设置警告数据
                warningDataRowCurrentList.forEach(abnormalItem => {
                    let keyName = abnormalItem.filedName;
                    let abnormalCell = newRow.colData.find(colItem => colItem.keyName === keyName);
                    if(abnormalCell) {
                        if(abnormalCell.abnormalData) {
                            abnormalCell.abnormalData.warningData = {
                                ...abnormalItem,
                                tagType: "warning"
                            }
                        }else {
                            abnormalCell.abnormalData = {
                                warningData: {
                                    ...abnormalItem,
                                    tagType: "warning"
                                }
                            }
                        }
                    }
                });
                return newRow;
            });
        },
        // 表格异常定位
        handleTableAbnormalPosition(){
            if(!this.abnormalData || !this.abnormalData.errorMessageList || !this.abnormalData.errorMessageList.length) {
                return this.$toast({
                    message: "暂无异常数据",
                    position: "top",
                    getContainer: "body"
                })
            };
            this.$toast({
                type: "html",
                message: `
                    <div style="display: flex;align-items: center;">
                    <i class="iconfont icon-toast-error" style="font-size: 22px;color: #FF484A;margin-right: 6px;"></i>
                    <div style="font-size: 14px;line-height: 22px;white-space: nowrap;">存在异常数据，修改后提交</div>
                    </div>
                `,
                position: "top",
                // duration: 0,
                className: "material-data-upload-toast",
                getContainer: "body"
            });
            this.tableData.find(row => {
                let abnormalDataCell = row.colData.find(cell => cell.abnormalData && cell.abnormalData.errorData);
                abnormalDataCell && document.querySelector(`.${abnormalDataCell.class}`).scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center"
                });
                return Boolean(abnormalDataCell);
            })
        },
        // 表格警告定位
        handleTableWarningPosition(){
            if(!this.abnormalData || !this.abnormalData.warningMessageList || !this.abnormalData.warningMessageList.length) {
                return this.$toast({
                    message: "暂无警告数据",
                    position: "top",
                    getContainer: "body"
                })
            };
            this.warningPositionCurrent = this.warningPositionList[this.warningPositionCurrent+1] ? this.warningPositionCurrent+1 : 0;
            this.getWarningPositionList();
            if(!this.warningPositionList.length) return;
            document.querySelector(`.${this.warningPositionList[this.warningPositionCurrent].class}`).scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center"
            });
            this.$toast({
                type: "html",
                message: `
                    <div style="display: flex;align-items: center;">
                    <i class="iconfont icon-warning" style="font-size: 16px;color: #FFBD2D;margin-right: 6px;"></i>
                    <div style="font-size: 14px;line-height: 22px;white-space: nowrap;">${this.warningPositionList[this.warningPositionCurrent].abnormalData.warningData.message}</div>
                    </div>
                `,
                position: "top",
                className: "material-data-upload-toast",
                getContainer: "body"
            });
            /* this.tableData.find(row => {
                let warningDataList = row.colData.filter(cell => cell.abnormalData && cell.abnormalData.warningData);
                message = 
                document.querySelector(`.${warningDataList[this.warningPositionCurrent].class}`).scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "center"
                });
                return Boolean();
            }); */
        },
        getWarningPositionList(){
            let warningPositionList = this.tableData.reduce((list,row) => {
                let warningDataList = row.colData.filter(cell => cell.abnormalData && cell.abnormalData.warningData);
                return [...list,...warningDataList];
            },[]);
            this.warningPositionList = warningPositionList;
        },
        // 领料数据表单提交
        materialDataFormSubmit(data){
            this.tableData[data.serialNumber - 1] = {
                colData: this.tmsExcelColOptions.map((tmsExcelColItem,tmsExcelColIndex) => ({
                    label: tmsExcelColItem.tmsLabel,
                    value: data[tmsExcelColItem.keyName],
                    class: `row${data.serialNumber}-col${tmsExcelColIndex + 1}`,
                    rowIndex: data.serialNumber - 1,
                    colIndex: tmsExcelColIndex,
                    keyName: tmsExcelColItem.keyName,
                })),
                class: `row${data.serialNumber}`,
                rowIndex: data.serialNumber - 1
            };
            this.$forceUpdate();
            this.abnormalData.errorMessageList = this.abnormalData.errorMessageList.filter(abnormalItem => abnormalItem.rawIndex !== data.serialNumber - 1);
        },
        handleEdit(row){
            this.$store.commit("DATA_UPLOAD_ADD_EDIT_QUERY",this.deepClone({
                form: {
                    materialSupplier: this.getForm().materialSupplier,
                    serialNumber: row.rowIndex + 1,
                    ...row.colData.reduce((obj,cell) => {
                        return {
                            ...obj,
                            [cell.keyName]: cell.abnormalData && cell.abnormalData.errorData &&cell.abnormalData.errorData.filedName === cell.keyName ? "" : cell.value,
                        }
                    },{})
                },
                oldForm: row.colData.reduce((obj,cell) => {
                    return {
                        ...obj,
                        [cell.keyName]: cell.value,
                    }
                },{}),
            }));
            this.$router.push({ 
                path: "/material/materialDataUpload/addEdit",
                query: {
                    AES: this.$route.query.AES,
                }
             });
        },
        async handleRemove(row,index){
            await this.modal({
                title: "是否移除该数据",
                content: `数据移除后确认生成任务<span style="color: #FF484A;">不会导入</span>该条数据，请确认`,
                themeColor: "#FF484A"
            });
            this.tableData.splice(index,1);
        },
        handleWarningToast(cell){
            this.$toast({
                type: "html",
                message: `
                    <div style="display: flex;align-items: center;">
                    <i class="iconfont icon-warning" style="font-size: 16px;color: #FFBD2D;margin-right: 6px;"></i>
                    <div style="font-size: 14px;line-height: 22px;white-space: nowrap;">${cell.abnormalData.warningData.message}</div>
                    </div>
                `,
                position: "top",
                className: "material-data-upload-toast",
                getContainer: "body"
            });
        }
    }
}
</script>

<style scoped lang="scss">
    .table-container {
      width: 100%;
      overflow: auto;
      table {
        border-collapse: collapse;
        width: 100%;
        table-layout: fixed;
        th {
          background-color: #FFF;
        }
        th,
        td {
          border: 1px solid #ddd;
          padding: 8px;
          background-color: #FFF;
          font-size: 12px;
          line-height: 20px;
          overflow: hidden;
          word-wrap: break-word;
          white-space: normal;
        }
        td {
            position: relative;
            overflow: hidden;
        }
    
        .fixed-column {
          position: sticky;
          right: 0;
          background-color: #F8F8F8;
          z-index: 1;
          color: #FFBD2D;
          font-size: 12px;
          line-height: 20px;
        }
        .abnormal-cell__error {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            z-index: 1;
            background-color: #FEEEEE;
            font-size: 10px;
            line-height: 15px;
            color: #F6585A;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
        }
        .abnormal-cell__warning {
            margin-right: 16px;
        }
      }
    }
</style>